import { Color } from 'state/color'
import { AttributeGroup } from 'state/attributeGroup'// // import { Color } from 'state/color'
import { Product } from 'state/product'
import { classList } from 'MK/DOM/fns/classList'

export const state = {
  initialize: function (index) {
    MK.indexes = index

    // If index (product, category, and attribute) are present, proceed with product initialization.
    // Else, return.
    if (!index || !index.products) {
      console.log('DEBUG (state): Page does not meet criteria for product initialization.  Skipping.')
      return
    }

    console.log('DEBUG (state): Initializing state.')

    // If page contains no attribute groups, add noRefine class to body to prevent attribute filters from displaying.
    if (!index.attributeGroups || index.attributeGroups && index.attributeGroups.length === 0) {
      console.log('(state) Hiding attribute groups.')
      classList.add(document.body, 'noRefine')
    }

    const opts = {
      target: index,
      initiator: 'state:initialize'
    }

    MK.events.emit('color:initialize', opts)
    MK.events.emit('products:initialize', opts)
    MK.events.emit('attribute:groups:initialize', opts)

    if (MK.page && MK.page.type === 'attribute') {
      console.log('DEBUG (state.initialize): Delayed product initialization due to active attribute selection.  Proceeding to initialize products.')
      MK.events.emit('products:updateDOM', { initiator: 'State.initialize' })
    } else {
      // Add product nodes to DOM
      if (!window.MK.page.is.outOfStock) {
        MK.events.emit('products:updateDOM', {
          initiator: 'Product.initialize'
        })
      }
    }

    MK.utils.lazyLoad.observe()
  }
}
